module.exports = __webpack_public_path__ + "img/116.9e217197.jpg";